export const REFERENCE_FIELD_MAP = {
  courseId: "courses",
  classId: "classes",
  departmentId: "departments",
  teacherId: "teachers",
};

export function unwrapListPayload(response) {
  const envelope = response?.data ?? response;
  if (Array.isArray(envelope)) return envelope;
  if (Array.isArray(envelope?.data)) return envelope.data;
  if (Array.isArray(envelope?.data?.data)) return envelope.data.data;
  if (Array.isArray(envelope?.rows)) return envelope.rows;
  return [];
}

export function buildReferenceMap(
  items,
  { idKeys = ["id", "_id", "courseId", "classId"], nameKeys = ["name", "courseName", "className", "title", "fullName"] } = {},
) {
  const map = {};
  for (const item of items || []) {
    const id = idKeys.map((key) => item?.[key]).find((value) => value != null);
    const name = nameKeys.map((key) => item?.[key]).find((value) => value != null && String(value).trim());
    if (id != null && name) {
      map[String(id)] = String(name).trim();
    }
  }
  return map;
}

export function resolveReferenceFieldValue(value, field, references = {}) {
  const mapKey = REFERENCE_FIELD_MAP[field];
  if (!mapKey || value == null || value === "") return null;
  return references?.[mapKey]?.[String(value)] || null;
}

export function collectReferenceIds(logs = []) {
  const ids = {
    courses: new Set(),
    classes: new Set(),
    departments: new Set(),
    teachers: new Set(),
  };

  for (const log of logs) {
    for (const payload of [log?.oldValue, log?.newValue]) {
      if (!payload || typeof payload !== "object") continue;
      if (payload.courseId != null) ids.courses.add(String(payload.courseId));
      if (payload.classId != null) ids.classes.add(String(payload.classId));
      if (payload.departmentId != null) ids.departments.add(String(payload.departmentId));
      if (payload.teacherId != null) ids.teachers.add(String(payload.teacherId));
    }
  }

  return ids;
}
